import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
import FlashController from "./flash_controller"
import HelloController from "./hello_controller"
import ModalFormController from "./modal_form_controller"
import PrefillController from "./prefill_controller"
import RosterParticipantsController from "./roster_participants_controller"
import ShareController from "./share_controller"
import SignaturePadController from "./signature_pad_controller"
import ThemeSwitcherController from "./theme_switcher_controller"

application.register("auto-submit", AutoSubmitController)
application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("modal-form", ModalFormController)
application.register("prefill", PrefillController)
application.register("roster-participants", RosterParticipantsController)
application.register("share", ShareController)
application.register("signature-pad", SignaturePadController)
application.register("theme-switcher", ThemeSwitcherController)
